import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  CorporationSkillsConfiguration,
  CorporationSkillsConfigurationRequest,
} from '../../entities/corporation-skill-frameworks.model';
import { DashboardApiService } from '../db-api.service';

const CORP_CONFIGURATION_URL = '/v1/corporation/skills_configuration';

@Injectable({
  providedIn: 'root',
})
export class CorporationSkillsConfigurationApiService extends DashboardApiService {
  getConfiguration(): Observable<CorporationSkillsConfiguration> {
    return this._get(CORP_CONFIGURATION_URL).pipe(
      map((res) => this._handleResponse(res, 'skills_configuration')),
      catchError((res) => this._handleError(res)),
    );
  }

  updateConfiguration(
    request: Partial<CorporationSkillsConfigurationRequest>,
  ): Observable<CorporationSkillsConfiguration> {
    return this._put(CORP_CONFIGURATION_URL, { skills_configuration: request }).pipe(
      map((res) => this._handleResponse(res, 'skills_configuration')),
      catchError((res) => this._handleError(res)),
    );
  }
}
